<template>
  <div class="contact-form">
    <form>
      <div class="form-group">
        <input type="text" v-model="formData.name" class="form-control" placeholder="Your Name" required aria-required="true">
      </div>
      <div class="form-group">
        <input type="email" v-model="formData.email" class="form-control" placeholder="Your E-Mail" required aria-required="true">
      </div>
      <div class="form-group">
        <input type="text" v-model="formData.subject" class="form-control" placeholder="Subject">
      </div>
      <div class="form-group">
        <textarea class="form-control" v-model="formData.message" rows="5" placeholder="Message" required aria-required="true"></textarea>
      </div>
      <div class="row my-3 submit-status px-3">
        <p v-show="fieldsEmpty" class="validation error">{{data.pleaseFill}}</p>
        <p v-show="submitSuccess" class="text text-center success">{{data.success}}</p>
        <p v-show="submitError" class="text text-center error">{{data.error}}</p>
      </div>
      <div class="row my-5">
        <button type="button" @click="onFormSubmit" class="btn send-btn mx-auto">{{data.send}}</button>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  props: ['data'],
  data () {
    return {
      submitSuccess: false,
      submitError: false,
      fieldsEmpty: false,
      formData: {
        name: '',
        email: '',
        subject: '',
        message: ''
      }
    }
  },
  methods: {
    onFormSubmit () {

      const isFormValid = this.isFormValid(this.formData);

      if (isFormValid) {
        this.submitForm(this.formData);
      }
    },
    isFormValid (formData) {
      if (formData.name === '' || formData.email === '' || formData.message === '') {
        this.fieldsEmpty = true;
        return false;
      } else {
        this.fieldsEmpty = false;
        return true;
      }
   },
   async submitForm(formData) {

    const contactUrl = this.data.contactUrl;

    const formattedData = new URLSearchParams({
      'contact-name': formData.name,
      'contact-email': formData.email,
      'message': `Subject: ${formData.subject}, Message: ${formData.message}`
    }).toString();

    const response = await fetch(contactUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formattedData
      });

      if (response.status === 200) {
        this.submitSuccess = true;
        this.resetForm();
      } else {
        this.submitError = true;
      }
    },
    resetForm () {
      setTimeout(() => {
        this.formData.name = '';
        this.formData.email = '';
        this.formData.subject = '';
        this.formData.message = '';
        this.submitSuccess = false;
      }, 3000);
    }
  }
}
</script>

<style lang="scss">
.contact-form {

  .form-control {
    min-height: 4rem;
    border: none;
    border-radius: 0.625rem;
  }

  .send-btn {
    color: $white;
    font-weight: bold;
    background-color: $secondary;
    letter-spacing: 2px;
    text-transform: uppercase;
    padding: 1rem 2rem;
    border: none;
    border-radius: 0.625rem;
    box-shadow: 0px 16px 16px -8px rgba($color: $secondary, $alpha: 0.7);

    &:hover {
      box-shadow: none;
      transform: translateY(5px);
    }
  }

  .submit-status {
    text-align: center;
    font-size: 1rem;

    .success {
      color: $secondary;
    }

    .error {
      color: rgb(136, 53, 53);
    }
  }
}
</style>